import { isProxy, objectCountUtils, proxyUtils, storeUtils, toParentWatchProxy, watchUpdates } from '@fanfanlo'
import _ from 'lodash'
import { createProjectDefultData, IProjectData } from '../project'
import { createDefultTriggerActionGroup } from '../trigger-action/'
export const s = storeUtils.namespace('project')
const listName = 'list'
const draftName = 'draft'

function loadProjectList():IProjectData[]{
    let list = s.read(listName) as IProjectData[]
    if(!_.isArray(list) || !list)list = []
    const res = prepareProjectList(list)
    return res
}

function loadDraft():IProjectData[]{
    let list = s.read(draftName) as IProjectData[]
    if(!_.isArray(list) || !list)list = []
    const res = prepareProjectList(list)
    return res
}

function prepareProjectList(list:IProjectData[]){
    return list.map(p=>{
        if(!p.triggerActionGroup)p.triggerActionGroup = createDefultTriggerActionGroup()
        return _.merge(createProjectDefultData(), p)
    })
}

const list:IProjectData[] = toParentWatchProxy(loadProjectList())
const draft:IProjectData[] = toParentWatchProxy(loadDraft())
function printList(){
    console.log('storage initialize list=', objectCountUtils.getObjectCount(list), list)
list.forEach((p, index)=>{
    console.log('storage initialize list item=', objectCountUtils.getObjectCount(p), 'index=', index, 'p=',p, 'isproxy=', isProxy(p))
})
}
// printList()
function printDraft(){
    console.log('storage initialize draft=', objectCountUtils.getObjectCount(draft), draft)
draft.forEach((p, index)=>{
    console.log('storage initialize draft item=', objectCountUtils.getObjectCount(p), 'index=', index, 'p=',p, 'isproxy=', isProxy(p))
})
}
// printDraft()
function init(){
    watchUpdates(list, ()=>{
        s.write(listName, list, true)
        // console.log('list changed', list)
        // printList()
    })
    watchUpdates(draft, ()=>{
        proxyUtils.runPauseProxyFn(()=>{
            s.write(draftName, draft, true)
            // console.log('draft changed', draft)
        })
        // printDraft()
    })
}

function saveProject(project:IProjectData){
    const copy = _.cloneDeep(project)
    let index = list.findIndex(p=>p.id === copy.id)
    if(index === -1)index = list.length
    list[index] = copy   
    // let draftIndex = draft.findIndex(p=>p.id === copy.id)
    // if(draftIndex > -1){
    //     draft.splice(draftIndex, 1)
    // }
}

function findSavedProject(id:string){
    return list.find(p=>p.id == id)
}

function findProject(id:string){
    return list.find(p=>p.id == id) ||draft.find(p=>p.id == id)
}

function findDraftOrSavedProject(id:string){
    return draft.find(p=>p.id == id) || list.find(p=>p.id == id)
}

function deleteProject(id:string){
    let index = list.findIndex(p=>p.id === id)
    if(index !== -1)list.splice(index, 1)
    s.write(listName, list, true)
    deleteDraft(id)
}

function addDraft(project:IProjectData):IProjectData{
    const p = proxyUtils.runPauseProxyFn(()=>{
        return _.cloneDeep(project)
    })
    let index = draft.findIndex(p=>p.id === project.id)
    if(index == -1)index = draft.length
    draft[index] = p
    return draft[index]
}

function deleteDraft(id:string){
    let index = draft.findIndex(p=>p.id === id)
    if(index !== -1)draft.splice(index, 1)
    s.write(draftName, draft, true)
}

function getListCopy(){
    const res = [...list]
    return res
}

function getDraftCopy(){
    return [...draft]
}
export const projectStore = {
    list,
    init,
    saveProject,
    findProject,
    deleteProject,
    addDraft,
    deleteDraft,
    draft,
    getListCopy,
    getDraftCopy,
    findDraftOrSavedProject,
    findSavedProject,
}

if(typeof window !== 'undefined'){
    (window as any).getProjectStore = function(){
        return projectStore
    };
    (window as any).showA = function(s:string){
        alert(s || 'hello')
    }
}